import { NgModule } from 'ng-metadata/core';

import {PrmUploadFile} from './uploadFile/uploadFile.directive';

import { DepositFormService } from './depositForm.service';
import { UploadFileModule } from './uploadFile/uploadFile.module';


@NgModule({
    declarations: [
       PrmUploadFile
    ],
    providers: [
        DepositFormService
    ],
    imports: [
        UploadFileModule
    ]
})
export class DepositFormModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/deposit/depositForm.module.ts